@if (parcels().length) {
  <ol class="ps-5" type="1">
    @for (item of parcels(); track $index) {
      <li>
        <div class="row">
          <div class='d-flex align-items-center' [ngClass]="{ 'col-md-3': showActions(), 'col-md-4': !showActions() }">
            <app-label label='Gmina:'>
              {{ item?.municipality || '-' }}
            </app-label>
          </div>
          <div class='d-flex align-items-center' [ngClass]="{ 'col-md-3': showActions(), 'col-md-4': !showActions() }">
            <app-label label='Obręb:'>
              {{ item?.precinct || '-' }}
            </app-label>
          </div>
          <div class='d-flex align-items-center' [ngClass]="{ 'col-md-3': showActions(), 'col-md-4': !showActions() }">
            <app-label label='Działka nr:'>
              {{ item?.registrationNumber || '-' }}
            </app-label>
          </div>
          @if (showActions()) {
            <div class="col-md-3">
              <button
                (click)='onEdit.emit({ v: item, i: $index })'
                class='btn btn-secondary icon-btn'
                title='Edytuj'
                type="button"
                [disabled]='!canEdit()'>
                <i class='fa fa-pencil-alt'></i>
              </button>
              &nbsp;
              <button
                [disabled]='!canEdit()'
                type='button'
                class='btn btn-red-secondary icon-btn' title='Usuń z listy'
                (click)='onRemove.emit($index)'>
                <i class='fa fa-trash-alt'></i>
              </button>
            </div>
          }
          <div class="col-md-4">
            <app-label label="Miejscowość:">
              {{ item?.city || '-' }}
            </app-label>
          </div>
        </div>
      </li>
      @if (!$last) {
        <br>
      }
    }
  </ol>
} @else {
  <app-alert type="info" alertTitle="Brak dodanych działek!" [closable]="false"></app-alert>
}

